import { withLazyComponent } from '@document/utils/lazy-component';
import { lazy } from 'react';

export const BuyerInfoPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./BuyerInfoPage')).BuyerInfoPage,
  }))
);

export const BuyerOfferScorecardsPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./BuyerOfferScorecardsPage'))
      .BuyerOfferScorecardsPage,
  }))
);

export const BuyersPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./BuyersPage')).BuyersPage,
  }))
);
